import SectionSubtitle from '../../../../components/SectionSubtitle';
import SectionTitle from '../../../../components/SectionTitle';
import style from './Advantages.module.scss';
import { advantages } from './advantages';
import Card from '../../../../components/AdvantagesCard';
import bckg_1 from './assets/bckg_1';
import bckg_2 from './assets/bckg_2';

const AdvantagesSection = () => {
  return (
    <section className={style.advantages}>
      {/* <div className={style.advantages__bg1}>{bckg_1}</div>
      <div className={style.advantages__bg2}>{bckg_2}</div> */}

      <div className='container'>
        <SectionTitle className={style.advantages__title}>About</SectionTitle>
        <SectionSubtitle className={style.advantages__subtitle}>
          <span>AlgoQuant</span> is a company focused on{' '}
          <span>building algorithmic trading</span> solutions. Our{' '}
          <span>professional team</span> brings significant <br /> market
          experience and state of art trading ideas. Algoquant{' '}
          <span>
            develops its own products and works with external <br /> teams
          </span>{' '}
          to achieve optimal results. Over the years, we have continued to
          expand our expertise, adapt to changing <br /> market conditions and
          compete at the highest level.
        </SectionSubtitle>
        <div className={style.advantagesBody}>
          {advantages.map((item, index) => (
            <Card
              className={style.advantagesBody__item}
              key={index}
              value={item.value}
              label={item.label}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
